import { createFetchApi, FetchMiddlewares } from '@backstage/core-app-api';
import {
  ApiBlueprint,
  configApiRef,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';

// Overrides the built-in `fetch` API to force the user back to the sign-in
// page whenever a backend call comes back with 401 Unauthorized, instead of
// silently failing or leaving a stale session in place.
const fetchApiWithAuthGuard = ApiBlueprint.make({
  name: 'fetch',
  params: define =>
    define({
      api: fetchApiRef,
      deps: {
        configApi: configApiRef,
        identityApi: identityApiRef,
        discoveryApi: discoveryApiRef,
      },
      factory: ({ configApi, identityApi, discoveryApi }) =>
        createFetchApi({
          middleware: [
            FetchMiddlewares.resolvePluginProtocol({ discoveryApi }),
            FetchMiddlewares.injectIdentityAuth({
              identityApi,
              config: configApi,
            }),
            {
              apply: (next: typeof fetch): typeof fetch =>
                async (input, init) => {
                  const response = await next(input, init);
                  if (response.status === 401) {
                    await identityApi.signOut();
                    window.location.reload();
                  }
                  return response;
                },
            },
          ],
        }),
    }),
});

export const authGuardModule = createFrontendModule({
  pluginId: 'app',
  extensions: [fetchApiWithAuthGuard],
});
